import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BRAND, errMsg } from "./constants";

const SERVICES = [["food", "Food Assist"], ["city_explore", "City Explore"], ["luggage", "Luggage Help"], ["cab", "Need Cab or Auto"], ["networking", "Business Networking"], ["flatmate", "Flatmate Interested"], ["extend", "Extend Stay Request"], ["feedback", "Feedback for Stay"]];

export function SettingsPanel({ property, authFetch, API, onSaved }) {
  const [f, setF] = useState({});
  useEffect(() => {
    setF({ cgst_pct: property.cgst_pct ?? 6, sgst_pct: property.sgst_pct ?? 6, igst_pct: property.igst_pct ?? 12, commission_pct: property.commission_pct ?? 0,
      assist_services: property.assist_services ?? SERVICES.map(([k]) => k), booking_rules: property.booking_rules || "", address: property.address || "" });
  }, [property]);
  const num = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const toggle = (k) => setF({ ...f, assist_services: f.assist_services.includes(k) ? f.assist_services.filter((x) => x !== k) : [...f.assist_services, k] });
  const save = async () => {
    try {
      await authFetch({ method: "patch", url: `${API}/homestay/properties/${property.id}/settings`, data: { ...f, cgst_pct: +f.cgst_pct, sgst_pct: +f.sgst_pct, igst_pct: +f.igst_pct, commission_pct: +f.commission_pct } });
      toast.success("Property settings saved"); onSaved();
    } catch (e) { toast.error(errMsg(e, "Could not save settings")); }
  };
  if (!f.assist_services) return null;
  const cls = "mt-1 w-full rounded-xl border-2 px-3 py-2 text-sm";
  const lbl = "text-[10px] uppercase tracking-widest font-bold";
  return (
    <div data-testid="settings-panel" className="grid lg:grid-cols-2 gap-4">
      <div className="rounded-2xl border-2 bg-white p-4" style={{ borderColor: BRAND.line }}>
        <div className="text-sm font-bold" style={{ color: BRAND.green }}>Tax & commission</div>
        <div className="mt-2 grid grid-cols-2 gap-3">
          {[["cgst_pct", "CGST %"], ["sgst_pct", "SGST %"], ["igst_pct", "IGST %"], ["commission_pct", "Booking commission %"]].map(([k, l]) => (
            <label key={k} className={lbl} style={{ color: BRAND.muted }}>{l}<input type="number" step="0.5" min={0} data-testid={`settings-${k}`} className={cls} value={f[k]} onChange={num(k)} /></label>
          ))}
        </div>
        <label className={`${lbl} block mt-3`} style={{ color: BRAND.muted }}>Property address (sent in booking confirmation)<input data-testid="settings-address" className={cls} value={f.address} onChange={num("address")} /></label>
        <label className={`${lbl} block mt-3`} style={{ color: BRAND.muted }}>Booking rules<textarea rows={3} data-testid="settings-booking-rules" className={cls} value={f.booking_rules} onChange={num("booking_rules")} placeholder="ID mandatory · 24h cancellation · Check-in 12 PM / check-out 9 AM" /></label>
      </div>
      <div className="rounded-2xl border-2 bg-white p-4" style={{ borderColor: BRAND.line }}>
        <div className="text-sm font-bold" style={{ color: BRAND.green }}>Assist services shown to guests</div>
        <div className="mt-2 grid grid-cols-2 gap-2">
          {SERVICES.map(([k, l]) => (
            <label key={k} data-testid={`settings-service-${k}`} className="flex items-center gap-2 rounded-xl border-2 px-3 py-2 text-sm cursor-pointer" style={{ borderColor: f.assist_services.includes(k) ? BRAND.green : BRAND.line }}>
              <input type="checkbox" checked={f.assist_services.includes(k)} onChange={() => toggle(k)} /> {l}
            </label>
          ))}
        </div>
        <button data-testid="settings-save-btn" onClick={save} className="mt-4 w-full rounded-full py-2.5 font-bold text-white" style={{ background: BRAND.green }}>Save settings</button>
      </div>
    </div>
  );
}
